// Custom cursor: an instant dot plus a square that trails the pointer and
// grows to enclose hovered links/buttons (soft-machine experiment).
// One rAF loop drives both; it sleeps whenever the pointer and square are
// settled, so the idle page costs zero frames. Fine pointers only.

if (matchMedia("(pointer:fine)").matches) {
  const dot = document.querySelector(".cursor-dot");
  const square = document.querySelector(".cursor-square");

  if (dot && square) {
    const IDLE = 32; // resting square size (size-8), mirrors cursor.css
    const PAD = 8; // breathing room around an enclosed element
    const LERP = 0.22; // trail easing per frame
    const REST = 0.5; // px — below this the square counts as settled

    let mx = -100; // pointer, parked offscreen until the first move
    let my = -100;
    let sx = -100; // square top-left
    let sy = -100;
    let sw = IDLE; // square size, mirrors cursor.css
    let sh = IDLE;
    let snapped = null; // enclosed element, if any
    let queued = false; // rAF already scheduled
    let blink = null; // in-flight blink, so re-snaps restart it (never the CSS grow)

    const tick = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(place);
      }
    };

    function place() {
      queued = false;
      dot.style.transform = `translate(${mx}px,${my}px) translate(-50%,-50%)`;
      if (!snapped) {
        sx += (mx - sw / 2 - sx) * LERP;
        sy += (my - sh / 2 - sy) * LERP;
        square.style.transform = `translate(${sx}px,${sy}px)`;
        if (Math.abs(mx - sw / 2 - sx) > REST || Math.abs(my - sh / 2 - sy) > REST) tick();
      }
    }

    // Enclose el (or rest when null). Skips repeat work for the same element;
    // position snaps instantly while CSS eases the size.
    const snap = (el) => {
      if (el === snapped) return;
      snapped = el;
      if (el) {
        const r = el.getBoundingClientRect();
        sw = Math.ceil(r.width + PAD * 2);
        sh = Math.ceil(r.height + PAD * 2);
        sx = r.left - PAD;
        sy = r.top - PAD;
        square.style.width = `${sw}px`;
        square.style.height = `${sh}px`;
        square.style.transform = `translate(${sx}px,${sy}px)`;
        // Blink twice while the square grows onto the element.
        if (blink) blink.cancel();
        // blink = square.animate(
        //   [{ opacity: 1 }, { opacity: 0 }, { opacity: 1 }],
        //   { duration: 450, easing: "ease-in-out" },
        // );
      } else {
        sw = IDLE;
        sh = IDLE;
        square.style.width = `${IDLE}px`;
        square.style.height = `${IDLE}px`;
        tick();
      }
    };

    addEventListener("pointermove", (e) => {
      mx = e.clientX;
      my = e.clientY;
      snap(e.target.closest?.("a,button"));
      tick();
    }, { passive: true });

    // Re-glue the enclosure if scrolling moves the element under a held pointer.
    addEventListener("scroll", () => {
      if (snapped) {
        const keep = snapped;
        snapped = null;
        snap(keep);
      }
    }, { passive: true });
  }
}
